module.exports = __webpack_public_path__ + "media/images/MR_comment-53fbba57.svg";